import React, { useCallback } from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { defaultLocale } from '@atlassian/jira-common-constants/src/supported-locales.tsx';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { useCurrentUser } from '@atlassian/jira-platform-services-user-current/src/main.tsx';
import { formatTimezonedWithLocale } from '@atlassian/jira-platform-utils-date-fns/src/main.tsx';
import { useObjectStoreState } from '@atlassian/jira-servicedesk-insight-object-details-store/src/controllers/store/index.tsx';
import messages from './messages.tsx';

const TIMESTAMP_FORMAT = 'MMMM d, yyyy, p';
const DEFAULT_TIME_ZONE = 'UTC';

export const ObjectDates = () => {
	const [{ objectDetails }] = useObjectStoreState();

	const { data } = useCurrentUser();
	const locale = data.user.locale ?? defaultLocale;
	const timeZone =
		('timeZone' in data.user ? data.user.timeZone : DEFAULT_TIME_ZONE) || DEFAULT_TIME_ZONE;
	const { formatMessage } = useIntl();

	const formatDate = useCallback(
		(timestamp: string) =>
			formatTimezonedWithLocale(new Date(timestamp), TIMESTAMP_FORMAT, locale, timeZone),
		[locale, timeZone],
	);

	if (!objectDetails) {
		return null;
	}

	return (
		<div>
			<DateLine>
				{formatMessage(messages.objectCreatedLabel, {
					date: formatDate(objectDetails.created),
				})}
			</DateLine>
			<DateLine>
				{formatMessage(messages.objectModifiedLabel, {
					date: formatDate(objectDetails.updated),
				})}
			</DateLine>
		</div>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DateLine = styled.div({
	font: token('font.body.UNSAFE_small'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	lineHeight: `${gridSize * 3}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text', colors.N800),
});
